const AlertsModule = {
  state: {
    alerts: []
  },
  mutations: {
    updateAlerts (state, alerts) {
      state.alerts = alerts
    },
    pushAlert (state, alert) {
      state.alerts.push(alert)
    },
    remove(state,index) {
      state.alerts.splice(index, 1)
    }
  }
};

export default AlertsModule;
